<div id="main-content">
  <app-navbar *ngIf="!hideNavbar"></app-navbar>
  <router-outlet></router-outlet>
  <app-toast-bar></app-toast-bar>
  <app-grey-overlay></app-grey-overlay>
</div>